import React from "react";
import { linkifyText } from "../lib/linkify";

export default function ArticleBody({ body, targets = [], currentSlug }) {
  // Flatten targets ({to, terms:[...]}) into {term, to} pairs, excluding current article.
  const pairs = [];
  targets
    .filter((tg) => tg.slug !== currentSlug && tg.slug_en !== currentSlug)
    .forEach((tg) => {
      (tg.terms || []).forEach((term) => {
        if (term && term.trim()) pairs.push({ term: term.trim(), to: tg.to });
      });
    });
  const blocks = (body || "").split(/\n{2,}/);
  return (
    <div className="space-y-6 text-lg leading-relaxed text-foreground/90 max-w-prose" data-testid="article-body">
      {blocks.map((block, i) => (
        <p key={i} className="whitespace-pre-line">
          {linkifyText(block, pairs, `b${i}`)}
        </p>
      ))}
    </div>
  );
}
